export const frontFilter = ['Rénovations totales', 'Cuisines', 'Salles de bains', 'Dressings'];
